import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const deleteFormSection = (formId: string, sectionId: string): ReturnType => {
    return Request.delete(`/data/forms/${formId}/sections/${sectionId}`);
};

export default deleteFormSection;
